import { render, staticRenderFns } from "./PacientesAntecedentesPatologicos.vue?vue&type=template&id=da023f76"
import script from "./PacientesAntecedentesPatologicos.vue?vue&type=script&lang=js"
export * from "./PacientesAntecedentesPatologicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports